import * as THREE from 'three'
import ObjThreeModelSingleton from '@/3d/core/ObjThreeModelSingleton'
import { Animation } from '@/3d/helpers/Animation'
import store from '../../store'

/**
 * @param {THREE.MeshPhongMaterial} materialFrom - material from change
 * @param {THREE.MeshPhongMaterial} materialTo - material to change
 * @param {String} objectType ['planet', 'clouds']
 * @param {THREE.object3D} object - name ob the object that changing
 * */
const smoothChangeMaterial = (materialFrom, materialTo, objectType, object) => {

  if(!store.state.animationPlaying) {
    store.commit('setAnimationPlaying', true)
    let model = ObjThreeModelSingleton.getInstance()
    if(objectType === 'clouds') {
      // console.log('clouds')
    }
    else if (objectType === 'planet') {
      const planet = model.sphere.clone()
      planet.material = materialFrom
      model.sphereGroup.add(planet)
      planet.material.depthTest = false
      planet.material.transparent = true
      object.material.transparent = true
      object.material.depthTest = false

      planet.material.opacity = 1

      object.material = materialTo
      object.material.opacity = 0

      const duration = 1200

      Animation.fadeIn(duration, object)
      Animation.fadeOut(duration, planet)

      setTimeout(() => {
        object.material.transparent = false
        object.material.depthTest = true
        planet.parent.remove(planet);
        planet.parent = undefined;

        store.commit('setAnimationPlaying', false)
      }, duration)
    }
    else {
      // console.log('smoothChangeMaterial : not found object type ', objectType)
    }
  }

}


export default smoothChangeMaterial
